"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryExternalSourceEntity = void 0;
const BadRequestError_1 = require("../GS/BadRequestError");
const InventoryExternalSourceDto_1 = require("./InventoryExternalSourceDto");
const validators_1 = require("../GS/validators");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
class InventoryExternalSourceEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, inventoryExternalSources) {
        super();
        this._requiredFieldsSetStatus = {
            inventoryProviderId: false,
            url: false,
            identifier: false,
            sourceType: false,
            ftpServer: false,
            ftpUser: false,
            ftpPass: false,
            remotePath: false,
            excludedFiles: false
        };
        this._dependencies = dependencies;
        if (inventoryExternalSources === undefined) {
            this._dto = new InventoryExternalSourceDto_1.InventoryExternalSourceDto();
        }
        else if (inventoryExternalSources instanceof InventoryExternalSourceDto_1.InventoryExternalSourceDto) {
            this._dto = new InventoryExternalSourceDto_1.InventoryExternalSourceDto(inventoryExternalSources);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (inventoryExternalSources instanceof InventoryExternalSourceEntity) {
            this._dto = new InventoryExternalSourceDto_1.InventoryExternalSourceDto(inventoryExternalSources._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new InventoryExternalSourceDto_1.InventoryExternalSourceDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getInventoryProviderId() {
        return this._dto.inventoryProviderId;
    }
    setInventoryProviderId(untrustedValue) {
        let _untrustedValue;
        this.clearError("inventoryProviderId");
        this._requiredFieldsSetStatus.inventoryProviderId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("inventoryProviderId", "Inventory Provider Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("inventoryProviderId", "Inventory Provider is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.inventoryProviderId) {
            return;
        }
        this._dto.inventoryProviderId = _untrustedValue;
        this._setIsDirty(true);
    }
    getUrl() {
        return this._dto.url;
    }
    setUrl(untrustedValue) {
        const maxLength = 100;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("url");
        this._requiredFieldsSetStatus.url = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("url", "Url is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("url", `Url has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.url) {
            return;
        }
        this._dto.url = _untrustedValue;
        this._setIsDirty(true);
    }
    getIdentifier() {
        return this._dto.identifier;
    }
    setIdentifier(untrustedValue) {
        const maxLength = 100;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("identifier");
        this._requiredFieldsSetStatus.identifier = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("identifier", "identifier is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("identifier", `identifier has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.identifier) {
            return;
        }
        this._dto.identifier = _untrustedValue;
        this._setIsDirty(true);
    }
    getSourceType() {
        return this._dto.sourceType;
    }
    setSourceType(untrustedValue) {
        const maxLength = 100;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("sourceType");
        this._requiredFieldsSetStatus.sourceType = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("sourceType", "Source Type is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("sourceType", `Source Type has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.sourceType) {
            return;
        }
        this._dto.sourceType = _untrustedValue;
        this._setIsDirty(true);
    }
    getFtpServer() {
        return this._dto.ftpServer;
    }
    setFtpServer(untrustedValue) {
        const maxLength = 100;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("ftpServer");
        this._requiredFieldsSetStatus.ftpServer = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("ftpServer", "Ftp Server is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("ftpServer", `Ftp Server has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.ftpServer) {
            return;
        }
        this._dto.ftpServer = _untrustedValue;
        this._setIsDirty(true);
    }
    getFtpUser() {
        return this._dto.ftpUser;
    }
    setFtpUser(untrustedValue) {
        const maxLength = 50;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("ftpUser");
        this._requiredFieldsSetStatus.ftpUser = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("ftpUser", "Ftp User is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("ftpUser", `Ftp User has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.ftpUser) {
            return;
        }
        this._dto.ftpUser = _untrustedValue;
        this._setIsDirty(true);
    }
    getFtpPass() {
        return this._dto.ftpPass;
    }
    setFtpPass(untrustedValue) {
        const maxLength = 50;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("ftpPass");
        this._requiredFieldsSetStatus.ftpPass = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("ftpPass", "Ftp User URL is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("ftpPass", `Ftp User URL has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.ftpPass) {
            return;
        }
        this._dto.ftpPass = _untrustedValue;
        this._setIsDirty(true);
    }
    getRemotePath() {
        return this._dto.remotePath;
    }
    setRemotePath(untrustedValue) {
        const maxLength = 100;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("remotePath");
        this._requiredFieldsSetStatus.remotePath = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("remotePath", "Remote Path is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("remotePath", `Remote Path has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.remotePath) {
            return;
        }
        this._dto.remotePath = _untrustedValue;
        this._setIsDirty(true);
    }
    getExcludedFiles() {
        return this._dto.excludedFiles;
    }
    setExcludedFiles(untrustedValue) {
        const maxLength = 100;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("excludedFiles");
        this._requiredFieldsSetStatus.excludedFiles = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("excludedFiles", "Excluded Files is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("excludedFiles", `Excluded Files has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.excludedFiles) {
            return;
        }
        this._dto.excludedFiles = _untrustedValue;
        this._setIsDirty(true);
    }
    getCreatedAt() {
        return this._dto.createdAt;
    }
    getUpdatedAt() {
        return this._dto.updatedAt;
    }
    loadAsync(id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.inventoryExternalSourceDatastore
                    .getAsync(id);
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("Departments is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.inventoryExternalSourceDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.inventoryExternalSourceDatastore
                        .updateAsync(this._dto);
                }
                this._dto.id = dto.id;
                this._dto.createdAt = dto.createdAt;
                this._dto.updatedAt = dto.updatedAt;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("Inventory External Sources cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.inventoryExternalSourceDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.InventoryExternalSourceEntity = InventoryExternalSourceEntity;
//# sourceMappingURL=InventoryExternalSourceEntity.js.map